import ControlledTable from "@/components/controlled-table";
import BasicTableWidget from "@/components/controlled-table/basic-table-widget";
import { Order } from "@/types";
import DateCell from "@/ui/date-cell";
import cn from "@/utils/class-names";
import { Text } from "rizzui";

interface RecentShipmentsProps {
    orders: Order[];
}

export default function RecentShipments({ orders }: RecentShipmentsProps) {
    const getColumns = () => [
        {
            title: <span className="block">Product Name</span>,
            dataIndex: "trackingNumber",
            key: "trackingNumber",
            width: 300,
            render: (trackingNumber: string) => <p>{trackingNumber}</p>,
        },
        {
            title: <span className="block">Estimated Delivery Date</span>,
            dataIndex: "estimatedDeliveryDate",
            key: "estimatedDeliveryDate",
            width: 300,
            render: (estimatedDeliveryDate: string) => (
                <p>{new Date(estimatedDeliveryDate).toLocaleDateString()}</p>
            ),
        },
        {
            title: <span className="block">shipmentProvider</span>,
            dataIndex: "shipmentProvider",
            key: "shipmentProvider",
            width: 200,
            render: (shipmentProvider: string) => <p>{shipmentProvider}</p>,
        },
        {
            title: <span className="block">shippingDate</span>,
            dataIndex: "shippingDate",
            key: "shippingDate",
            width: 200,
            render: (shippingDate: string) => (
                <p>{new Date(shippingDate).toLocaleDateString()}</p>
            ),
        },
        {
            title: <span className="ms-6 block">Cost</span>,
            dataIndex: "shippingCost",
            key: "shippingCost",
            width: 100,
            render: (shippingCost: number) => (
                <span className="ms-6 bold">
                    <strong>${shippingCost}</strong>
                </span>
            ),
        },
    ];

    return (
        <ControlledTable
            data={orders}
            columns={getColumns()}
            scroll={{ x: "100%", y: 240 }}
            sticky={true}
            variant="modern"
            className="mt-4"
        />
    );
}
